import { gql } from '@apollo/client';
import config from 'config';

const tagIndex = config.algolia.algolia_prefix + 'tags';
export const GET_TAG = gql`
    query searchTag($field: String!, $value: String!, $limit: Int) {
        searchTag(input: { field: $field, value: $value, limit: $limit }) {
            data {
                id
                name
                value
            }
        }
    }
`;

export const GET_TAG_FROM_ALGOLIA = gql`
    query LocationsQuery(
        $query: String!
        $filters: String!
        $hit: Number!
        $page: Number!
        $facets: [String]!
    ) {
        getTagFromAlgolia
            @algolia(
                __typename: "tagsAlgolia"
                index: ${tagIndex}
                filters: $filters
                hitsPerPage: $hit
                query: $query
                page: $page
                facets: $facets
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
